import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import './PriceView.css'

const PriceViewUI = ({context, messageList, price, selectedPriceId, selectMode, onSelect}) =>
  <div className={`sub_price_v
    ${selectedPriceId === price.priceId ? 'active' : ''}
    ${selectedPriceId !== price.priceId && selectMode ? 'update_mode' : ''}
  `}>
    <div className='internal' data-price-id={price.priceId} onClick={onSelect}>

      <div className='g_flex_h'>
        <span className='name'>{price.productName}</span>
        {
          selectedPriceId === price.priceId &&
          <div className='icon icon-check-square-o'></div>
        }
        {
          selectedPriceId !== price.priceId &&
          <div className='icon icon-square-o'></div>
        }
      </div>

      <h3 className='limit'>
        <MessageUI messageList={messageList} messageKey='c_n_projects' args={[price.planLimit]} />
      </h3>

      <div className='g_flex_h1 price_bill g_m_top_25'>
        <div className='price'>{price.pricingString}</div>
        {
          /* if interval is 1 year, "Billed yearly" is displayed */
          /* if interval is 2 year, "2 Billed yearly" is displayed */
          /* basically >1 intervalCount will be implemented if needed */
          price.billingIntervalCount > 1 &&
          <div className='intervalCount'>{price.billingIntervalCount}</div>
        }
        {(() => {
          switch (price.billingInterval) {
            case 'day':
              return <MessageUI className='g_small g_muted' messageList={messageList} messageKey='c_billed_daily' />
            case 'week':
              return <MessageUI className='g_small g_muted' messageList={messageList} messageKey='c_billed_weekly' />
            case 'month':
              return <MessageUI className='g_small g_muted' messageList={messageList} messageKey='c_billed_monthly' />
            case 'year':
              return <MessageUI className='g_small g_muted' messageList={messageList} messageKey='c_billed_yearly' />
            default:
          }
        })()}
      </div>

      {
        /* show only full trial period here if elligible */
        price.trialPeriodDays === price.trialPeriodDaysLeft && price.trialPeriodDaysLeft > 0 &&
        <MessageUI className='trial' messageList={messageList} messageKey='c_free_trial' args={[price.trialPeriodString]} />
      }
      {
        /* show only partial trial period here if available */
        price.trialPeriodDays !== price.trialPeriodDaysLeft && price.trialPeriodDaysLeft > 0 &&
        <React.Fragment>
          <MessageUI className='trial' messageList={messageList} messageKey='c_trial_remaining' />
          {' '}
          <MessageUI className='trial' messageList={messageList}
            messageKey={price.trialPeriodDaysLeft === 1 ? 'c_1_day' : 'c_n_days'} args={[price.trialPeriodDaysLeft]} />
        </React.Fragment>
      }
      {
        /* empty line if no trial available */
        !price.trialPeriodDaysLeft &&
        <span>&nbsp;</span>
      }
    </div>
  </div>

export default PriceViewUI
